import {createSelector} from "reselect";

const userStoreSelect = (state) => state.user;

const selectProfileInfo = createSelector(
  userStoreSelect,
  (state) => state.info
);

export const telegramInfoSelector = createSelector(
  userStoreSelect,
  (state) => state.telegram
);

export const userIdSelector = createSelector(
  selectProfileInfo,
  (state) => state.id
);

export const projectsSelector = createSelector(
  userStoreSelect,
  (state) => state.projects,
);

export const adminProjectsSelector = createSelector(
  userStoreSelect,
  (state) => state.projects.filter((project) => project.is_user_project_admin),
);

export const avatarSelector = createSelector(
  selectProfileInfo,
  (state) => state.avatar,
);

export const fullNameSelector = createSelector(
  selectProfileInfo,
  (state) => `${state.firstName || state.email} ${state.lastName || ""}`
);

export const globalRoleSelector = createSelector(
  userStoreSelect,
  (state) => state.globalRole
);

export const globalRoleSelect = (state) => state.user.globalRole;